import { Route } from '@angular/router';
import { portalInmobiliariasPersonalizeGuard } from './pages/login/portal-inmobiliarias-personalize.session';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './pages/login/portal-inmobiliarias-login-page.component'
      ).then((m) => m.PortalInmobiliariasLoginPageComponent),
  },
  {
    path: 'personalize-password',
    canActivate: [portalInmobiliariasPersonalizeGuard],
    loadComponent: () =>
      import(
        './pages/login/portal-inmobiliarias-login-page.component'
      ).then((m) => m.PortalInmobiliariasLoginPageComponent),
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import(
        './pages/login/portal-inmobiliarias-login-page.component'
      ).then((m) => m.PortalInmobiliariasLoginPageComponent),
  },
];
